import { z } from 'zod';
import {
    ADDITIONAL_SERVICE_PRODUCT_TYPE_SCHEMA,
    ADDITIONAL_SERVICE_SUPPORTED_UNITS,
    ADDITIONAL_SERVICE_SUPPORTED_UNITS_SCHEMA,
} from '@schuettflix/interfaces';
import { CurrencyCodeSchema } from '@schuettflix/utils';
import { PriceSchema, PriceSchemaRules } from '@/shared/schemas/PriceSchema.ts';

export type AdditionalServiceSchemaParams = {
    errorMessages?: {
        required?: string;
    };
    priceRules?: PriceSchemaRules;
};

export type AdditionalServiceFormRule = {
    salesUnit?: { disabled?: boolean };
    salesQuantity?: { minValue?: number; unit?: ADDITIONAL_SERVICE_SUPPORTED_UNITS };
    disableDelete?: boolean;
};

export function getAdditionalServiceSchema(params?: AdditionalServiceSchemaParams) {
    const { errorMessages = {}, priceRules = {} } = params ?? {};
    const { required } = errorMessages;

    return z.object({
        identifier: z.string().optional(),
        productType: z.enum(ADDITIONAL_SERVICE_PRODUCT_TYPE_SCHEMA.options, {
            required_error: required,
            invalid_type_error: required,
        }),
        productName: z.string({ invalid_type_error: required }).trim().nonempty({ message: required }),
        salesQuantity: z.number({ invalid_type_error: required }).positive(required),
        salesUnit: z.enum(ADDITIONAL_SERVICE_SUPPORTED_UNITS_SCHEMA.options, { required_error: required }),
        salesPrice: PriceSchema({
            ...priceRules,
        }),
        salesTaxClassId: z.string({ message: required }),
        purchaseQuantity: z.number({ invalid_type_error: required }).positive(required),
        purchaseUnit: z.enum(ADDITIONAL_SERVICE_SUPPORTED_UNITS_SCHEMA.options, { required_error: required }),
        purchasePrice: PriceSchema({
            ...priceRules,
        }),
        purchaseTaxClassId: z.string({ message: required }),
        partnerOrganizationId: z.number({ required_error: required, invalid_type_error: required }),
        showZeroPurchasePrice: z.boolean(),
        showZeroSalesPrice: z.boolean(),
        currencyCode: CurrencyCodeSchema,
    });
}

export type AutomaticProductsFormAdditionalService = z.infer<ReturnType<typeof getAdditionalServiceSchema>>;
